/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
export const commonUiTranslations: any = {
    "en-GB": {
      "paging": {
        "prev": "prev",
        "next": "next",
        "of" : "of",
        "page" : "Page"
      },
      "datetime": {
        "time": "Time"
      }
    },
    "de-DE": {
      "paging": {
        "prev": "zurück",
        "next": "vor",
        "of" : "von",
        "page" : "Seite"
      },
      "datetime": {
        "time": "Uhrzeit"
      }
    }
};